import React, { useState, useEffect } from 'react'

import { InputProps } from '../interfaces'
import { SeedInput, Button } from './ProvablyFormStyled'
import UseProvablyHandlers from '../helperFunctions/UseProvablyHandlers'
import { Notifications } from 'library/constants'
export default function ProvablySeedInput({
  colors,
  sendSeed,
  handleNotification,
  audio,
  roundIsOn,
}: InputProps) {
  const { handleChange, handleSubmit, seed, seedError } = UseProvablyHandlers(
    sendSeed,
    handleNotification,
    audio,
  )
  const [anim, setanim] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setanim(false)
    }, 320)
  }, [anim])

  const handleChangeSeed = (seed: string) => {
    handleSubmit(seed)
    setanim(true)
  }

  return (
    <form
      autoComplete='off'
      onSubmit={e => {
        e.preventDefault()
      }}
      onClick={() =>
        roundIsOn && handleNotification(Notifications.cantChangeSeed)
      }
    >
      <SeedInput
        name='input'
        placeholder='New seed'
        spellCheck='false'
        onChange={(s: any) => handleChange(s)}
        value={seed}
        seedError={seedError}
        colors={colors}
        isDisabled={roundIsOn}
      />
      <Button
        colors={colors}
        anim={anim}
        isDisabled={roundIsOn}
        onClick={() => handleChangeSeed(seed)}
      >
        set
      </Button>
    </form>
  )
}
